import { markerColors } from '@fhs/maps/src/components/markers/marker-colors';
import {
  PIN_ART_HEIGHT,
  PIN_ART_WIDTH,
  PIN_BADGE_PATH,
  PIN_MONOGRAM_PATH,
  PIN_REGISTERED_MARK_PATH,
  PIN_TEARDROP_PATH,
} from '@fhs/maps/src/components/markers/store-pin-paths';

/**
 * Selected-store pin, drawn from the same artwork the native map uses in `@fhs/maps`: a red
 * teardrop for an open store and a dark one for a closed store.
 *
 * Web only. `google.maps.Marker` takes a data-uri icon plus an anchor point in image
 * coordinates, so these keep the artwork's own box and `index.web` anchors them on the tip.
 */
const buildWebPinSvg = (bodyColor: string) => `
<svg width="${PIN_ART_WIDTH}" height="${PIN_ART_HEIGHT}" fill="none" viewBox="0 0 ${PIN_ART_WIDTH} ${PIN_ART_HEIGHT}" xmlns="http://www.w3.org/2000/svg">
  <path d="${PIN_TEARDROP_PATH}" fill="${bodyColor}" />
  <path d="${PIN_REGISTERED_MARK_PATH}" fill="${markerColors.surface}" />
  <path d="${PIN_MONOGRAM_PATH}" fill="${markerColors.surface}" fill-rule="evenodd" />
  <path d="${PIN_BADGE_PATH}" fill="${markerColors.surface}" fill-rule="evenodd" />
</svg>
`;

export const storeSelectedOpenMarkerSvg = buildWebPinSvg(markerColors.selectedOpen);
export const storeSelectedClosedMarkerSvg = buildWebPinSvg(markerColors.selectedClosed);
